<script>
import BatteryIcon from '../assets/battery.svg'
import PlaneIcon from '../assets/plane.svg'
import WifiIcon from '../assets/cell-wifi.svg'
export default {
  data: () => {
    return {
      BatteryIcon,
      PlaneIcon,
      WifiIcon
    }
  }
}
</script>
<template>
  <div class="cell-phone-detect-box">
    <div class="guilde-text-wrapper">
      <p>请在使用手机扫码前，确保手机状态如下</p>
    </div>
    <div class="cell-phone-detect-content">
      <div class="cell-phone-detect-item">
        <div class="cell-phone-detect-icon">
          <img src="~images/fly-mode.png" />
        </div>
        <p class="cell-phone-detect-text">开启飞行模式</p>
      </div>
      <div class="cell-phone-detect-item">
        <div class="cell-phone-detect-icon">
          <img src="~images/wifi.png" />
        </div>
        <p class="cell-phone-detect-text">连接Wi-Fi</p>
      </div>
      <div class="cell-phone-detect-item">
        <div class="cell-phone-detect-icon">
          <img  src="~images/battery.png" />
        </div>
        <p class="cell-phone-detect-text">电量充足</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.cell-phone-detect-box {
  margin-left: 70px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cell-phone-detect-content {
  display: flex;
  margin-top: 24px;
  justify-content: space-between;
}
.cell-phone-detect-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 110px;
}
.cell-phone-detect-icon {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  img {
    width: 36px;
  }
}
.cell-phone-detect-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 19.6px;
  letter-spacing: 0px;
  color: #404968;
  margin-top: 12px;
  font-weight: 600;
}
</style>
